module.exports = __webpack_public_path__ + "static/product-detail-shipping-20241225-159045a31678ee1c848de2c5a94d386e.jpg";